
const ACT=0
const MI=1

module.exports.ACT=ACT
module.exports.MI=MI
